<div class="input-group">
	<span class="input-group-text">

		@if(errorToShow()){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
		@else{<i class="fa-fw fa-regular fa-hand-pointer"></i>}
	</span>
	<div class="form-floating">
		<kendo-multicolumncombobox class="form-select form-select-sm staff-selector" #list [data]="data()" placeholder="Select a staff..." (ngModelChange)="onValueChange($event)" textField="fullName" valueField="staffId" [kendoDropDownFilter]="{operator: 'contains',fields: ['fullName', 'department','status','email']}" size='large' [(ngModel)]="selectedValue" [disabled]="disabled()" [clearButton]="!required()" [popupSettings]="{popupClass: 'staff-selector-popup'}">
			<kendo-combobox-column field="fullName" title="Name" [width]="200">
				<ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
					<div class="d-flex align-items-center">
						@if(dataItem.avatar){
						<kendo-avatar [size]="'small'" [imageSrc]="dataItem.avatar"></kendo-avatar>
						}@else {
						<kendo-avatar [size]="'small'" [svgIcon]="userSvg"></kendo-avatar>
						}
						<span class="ms-1">{{ dataItem.fullName }}</span>
					</div>
				</ng-template>
			</kendo-combobox-column>
			<kendo-combobox-column field="status" title="Status" [width]="80">
				<ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
					<div [ngClass]="{'inactive': dataItem.status != 'Active'}">{{ dataItem.status }}</div>
				</ng-template>
			</kendo-combobox-column>
			<kendo-combobox-column field="email" title="Email" [width]="200"></kendo-combobox-column>
			<kendo-combobox-column field="department" title="Department" [width]="200"></kendo-combobox-column>
			<ng-template kendoMultiColumnComboBoxFooterTemplate>
				<strong> {{ data().length }} records in total </strong>
			</ng-template>
		</kendo-multicolumncombobox>
		<label class="color-gray d-flex" [for]="list">Staff Member</label>
	</div>
</div>
@if(errorToShow() !== '')
{
<div class="color-darkred text-end">{{errorToShow()}}</div>
}